import { IconProps } from "../../utils/global-types/global-types";

const ViewingsIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_9079_103324)">
        <path d="M10.475 4.669H7.522a.78.78 0 0 0-.781.781v3.306c0 .416.325.756.737.781l.453 3.65c.028.235.228.41.466.41h1.206a.467.467 0 0 0 .466-.41l.453-3.65a.78.78 0 0 0 .734-.78V5.45a.78.78 0 0 0-.78-.781M9 4.281A1.64 1.64 0 1 0 9 1a1.64 1.64 0 0 0 0 3.281"></path>
        <path d="M15.765 12c-.412-.378-.984-.71-1.697-.984a7 7 0 0 0-.421-.15.78.78 0 1 0-.491 1.48q.18.06.35.126c1.019.394 1.484.86 1.484 1.125 0 .266-.462.731-1.484 1.125-1.194.462-2.794.716-4.506.716s-3.313-.254-4.503-.716c-1.02-.394-1.485-.86-1.485-1.125 0-.266.463-.731 1.485-1.125q.168-.066.35-.125a.78.78 0 1 0-.49-1.481 8 8 0 0 0-.423.15c-.716.275-1.284.606-1.7.984-.65.594-.784 1.197-.784 1.597s.137 1.003.784 1.597c.413.378.984.71 1.697.984C5.297 16.71 7.097 17 9 17s3.703-.29 5.069-.822c.712-.275 1.284-.606 1.696-.984.65-.594.785-1.197.785-1.597s-.138-1.003-.785-1.597"></path>
      </g>
      <defs>
        <clipPath id="clip0_9079_103324">
          <path fill="#fff" d="M1 1h16v16H1z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default ViewingsIcon;
